import {Component, OnInit} from '@angular/core';
import {UserService} from '../services/user.service';
import {SessionService} from '../services/session.service';
import {SystemService} from '../services/system.service';
import {Version} from '../classes/version';
import {ConfigService} from '../../config/config.service';
import {Router} from '@angular/router';
import {CampaignService} from '../../campaign/campaign.service';

// import {Subscription} from 'rxjs/Subscription';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

    // subscription: Subscription;
    buildVersion: Version;
    reportingSubMenu = true;
    isAdmin: boolean;
    download: string;
    campaignId: number;
    campaignStartDate: Date;

    constructor(private systemService: SystemService,
                private userService: UserService,
                private sService: SessionService,
                private campaignService: CampaignService,
                private router: Router,
                private config: ConfigService) {
        if ('/reporting-members' === router.url || '/reporting-merchants' === router.url ||
            '/reporting-comparison' === router.url || '/reporting-internal-orders' === router.url) {
            this.reportingToggle();
        }

        this.download = config.terminalDownloadURL;
    }

    ngOnInit() {
        this.systemService.getVersion().subscribe(data => {
            this.buildVersion = new Version(data.major, data.minor, data.buildNumber, data.gitHash, data.gitBranch);
        });
        this.campaignService.campaignId.subscribe((val) => {
            this.campaignId = val;
        });
        this.campaignService.campaignStartDate.subscribe((val) => {
            this.campaignStartDate = val;
        });

        this.sService.getUserType() === 'USER' ? this.isAdmin = false : this.isAdmin = true;
    }

    isCampaignEnding(): Boolean {
        if (this.campaignStartDate === null) {
            return false;
        }

        const endDate = new Date(this.campaignStartDate.getTime() + 1209600000);
        return new Date().getTime() > endDate.getTime();
    }

    reportingToggle() {
        this.reportingSubMenu = !this.reportingSubMenu;
    }

    logOut() {
        this.userService.userLogout()
            .subscribe(
                data => {
                    this.sService.destroySessionCookie(true);
                    window.open(this.config.appURI, '_self');
                },
                error => {
                    this.sService.destroySessionCookie(true);
                    window.open(this.config.appURI, '_self');
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts